exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.model-box[data-v-2740ff68] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999999;\n  background-color: rgba(0, 0, 0, 0);\n}\n.model-box .model-text[data-v-2740ff68] {\n  position: absolute;\n  font-size: 0.43rem;\n  top: 50%;\n  left: 50%;\n  max-width: 80%;\n  color: #fff;\n  line-height: 1.5;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.8);\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  padding: 0.2rem 0.4rem;\n  -webkit-border-radius: 0.040rem;\n          border-radius: 0.040rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2740ff68","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/modelBox.vue
// module id = 306
// module chunks = 32